import { useEffect } from 'react';

/** Adds a robots noindex tag while enabled and removes only its own tag on cleanup. */
export function useNoIndex(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, [enabled]);
}
